import {Box, Button, Grid, Typography} from "@material-ui/core";
import {AddBox} from "@material-ui/icons";
import React, {FC, useState} from "react";
import {useTranslation} from "react-i18next";
import styled from "@emotion/styled";
import {GradientButton} from "../../../../../../../property-page-components/PropertyForm";
import {AccessibilityImages} from "../../../../../../../../../models/AccessibilityImages";
import PreviewModal from "./modals/preview/PreviewModal";
import ImageEditor from "./modals/image-editor/ImageEditor";

const CustomGradientButton = styled(GradientButton)`
  height: 42px;
  @media (max-width: 599px) {
    width: 100%;
  }
`

type PropsType = {
  selectedUnit: boolean;
  onSetShowImageEditor: (state: boolean) => void
}

const TopBlock: FC<PropsType> = ({selectedUnit, onSetShowImageEditor}) => {
  const { t } = useTranslation()
  const [showPreview, setShowPreview] = useState(false)

  const handlePreview = (show: boolean) => {
    setShowPreview(show)
  }
  const handleImageEditor = (show: boolean) => {
    onSetShowImageEditor(show)
  }

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} sm={8} md={6}>
        {selectedUnit ? (
          <Typography>{t('you_can_freely_change_the_images_ordering')}</Typography>
        ) : (
          <Typography>{t('you_can_drag_and_drop_the_block')}</Typography>
        )}
      </Grid>
      <Grid item xs={12} sm={4} md={6}>
        <Box display={'flex'} justifyContent={'end'}>
          <CustomGradientButton
            onClick={() => handleImageEditor(true)}
          >
            <AddBox/>
            {t('add_new_image')}
          </CustomGradientButton>
          <PreviewModal
            show={showPreview}
            onClose={() => handlePreview(false)}
          />
          <Box ml={2}>
            <CustomGradientButton onClick={() => handlePreview(true)}>
              <Typography style={{
                minWidth: '100px',
                textTransform: 'none',
                fontSize: '13px',
                padding: '0 5px',
                fontWeight: 500
              }}>{t('preview')}</Typography>
            </CustomGradientButton>
          </Box>
        </Box>
      </Grid>
    </Grid>
  )
}

export default TopBlock